// export default InvigilationAssign;
import {
  AppBar,
  Box,
  Button,
  Grid,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { useHistory, useParams } from 'react-router-dom';
import routes from '../../../../Utils/routes.json';
import { TabPanel } from '@material-ui/lab';
import { useEffect, useState } from 'react';
import KenCard from '../../../../global_components/KenCard';
import KenSelectWrap from '../../../../global_components/KenSelect';
import AddIcon from '@material-ui/icons/Add';
import SendIcon from '@material-ui/icons/SendRounded';
import AttachFile from '@material-ui/icons/AttachFileRounded';
import { Link } from 'react-router-dom';
import {
  RiFilterLine,
  RiCheckFill,
  RiNotification2Fill,
  RiNotification3Line,
} from 'react-icons/ri';
import { Message } from '@material-ui/icons';
import KenDateTimePicker from '../../../../global_components/KenDateTimePicker';
import KenSelect from '../../../../global_components/KenSelect';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
// Icons
import EditIcon from '@material-ui/icons/EditOutlined';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import {
  getInvigilator_s1_Data,
  getInvigilator_s1_Datas,
  getInvigilator_s2_Data,
  postInvigilator_s2_Data,
} from '../../../../Utils/apiServices';
import { sendMailInvigilator } from '../../../../Utils/sendMail';
import KenLoader from '../../../../Components/KenLoader';
const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'INVIGILATION AND PROCTORING ASSIGNMENT',
  },
];
export const AssignDropDown = [
  {
    label: 'Assigned',
    value: 'Assigned',
  },
  {
    label: 'Not Assigned',
    value: 'Not Assigned',
  },
];
export const roomData = [
  {
    label: 'room1',
    value: 'room1',
  },
  {
    label: 'room2',
    value: 'room2',
  },
  {
    label: 'room3',
    value: 'room3',
  },
  {
    label: 'room4',
    value: 'room4',
  },
];
const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    height: '28px',
    width: '78px',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    color: '#FFFFFF',
    background: 'orange',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  normal: {
    color: '#FFFFFF',
    background: '#55b0cd',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  publishGenerate: {
    color: '#FFFFFF',
    background: 'green',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  publishView: {
    color: '#FFFFFF',
    background: '#55b0cd',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Blue: {
    color: '#FFFF',
    background: '#03248F',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Green: {
    color: '#FFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '102px',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

const selectOptionsCourse = [
  {
    label: 'Automatic',
    value: 'Automatic',
  },
  {
    label: 'Manually',
    value: 'Manually',
  },
];

const InvigilationAssign = () => {
  function TabPanels(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  const CustomTableCell = ({ row, name, onChange }) => {
    const classes = useStyles();
    const { isEditMode } = row;
    return (
      <TableCell align="left" className={classes.tableCell}>
        {isEditMode ? (
          <Input
            value={row[name]}
            name={name}
            onChange={(e) => onChange(e, row)}
            className={classes.input}
          />
        ) : (
          row[name]
        )}
      </TableCell>
    );
  };
  const CustomTableCellForDropDown = ({ row, name, onChange }) => {
    const { isEditMode } = row;
    console.log('rowrowrowrowrowrowrowrowrowrow', row, { name });

    if (row.assign_to === '') {
      return <TableCell align="left">Not Assigned</TableCell>;
    } else {
      return (
        <TableCell align="left">
          {isEditMode ? (
            <Box>
              <Box>
                <KenSelect
                  name={name}
                  options={AssignDropDown}
                  value={row[name]}
                  dropdownColor="#ffffff"
                  onChange={(e) => onChange(e, row)}
                  required={true}
                />
              </Box>
            </Box>
          ) : (
            row[name]
          )}
        </TableCell>
      );
    }
    // return (
    //   <TableCell align="left">
    //     {isEditMode ? (
    //       <Box>
    //         <KenSelect
    //           name={name}
    //           options={AssignDropDown}
    //           value={row[name]}
    //           dropdownColor="#ffffff"
    //           onChange={(e) => onChange(e, row)}
    //           required={true}
    //         />
    //       </Box>
    //     ) : (
    //       row[name]
    //     )}
    //   </TableCell>
    // );
  };

  // let { Exam_id_id, id } = useParams();
  let Exam_id_id = useParams();
  console.log('Exam_id_idExam_id_idExam_id_id--------------', Exam_id_id.id);
  const [previous, setPrevious] = useState({});
  const onChange = (e, row) => {
    console.log('data', row.id, rows, e.target.value, e.target.name);
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };
  const onToggleEditMode = (check, id, index) => {
    const newData = [...rows];
    setRows((state) => {
      return newData.map((row) => {
        if (row.id === id) {
          console.log('postcallrow', row);
          if (check === 'done') {
            row.isEditMode = true;
            const payload = {
              contactId: row.faucltyId,
              facilityId: row.assign_to,
              examId: Exam_id_id.id,
              // facRole: row.carbs,
              // facEmail: row.calories,
              // isAllocated: row.venue_link,
              // sendEmail: false,
              status: 'Requested',
              // subject: '',
            };

            console.log('payloadpayload', payload);
            postInvigilator_s2_Data(payload)
              .then((res) => {
                if (res.success === 'true' || true) {
                  // alert(res.message);
                  row.isEditMode = false;
                  getInvigilator_s2_DataListing();
                }
                row.isEditMode = false;
              })
              .catch((err) => {
                console.log('Failed to add. Please try again.', err);
                row.isEditMode = false;
              });
          }
          if (check === 'edit') {
            return { ...row, isEditMode: !row.isEditMode };
          }
        }
        return row;
      });
    });
  };

  const onToggleEdit = (id, rowes) => {
    setRows((state) => {
      return rowes.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const onRevert = (id) => {
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return previous[id] ? previous[id] : row;
      }
      return row;
    });
    setRows(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleEdit(id, newRows);
  };
  const createData = (name, carbs, assign_to, venue_link) => ({
    id: name.replace(' ', '_'),
    name,
    carbs,
    // capacity,
    assign_to,
    venue_link,

    isEditMode: false,
  });
  const [rows, setRows] = useState([
    // {
    //   button: 'assign',
    //   faucltyId: 1,
    //   id: 1,
    //   name: 'faculty42',
    //   calories: 'faculty42@gmail.com',
    //   carbs: 'test1',
    //   // capacity: '',
    //   assign_to: 'ken52',
    //   venue_link: 'Assigned',
    // },
    // {
    //   button: 'assign',
    //   faucltyId: 2,
    //   id: 2,
    //   name: 'faculty44',
    //   calories: 'faculty44@gmail.com',
    //   carbs: 'test2',
    //   // capacity: '',
    //   assign_to: 'room2',
    //   venue_link: 'Assigned',
    // },
    // {
    //   button: 'assign',
    //   faucltyId: 3,
    //   id: 3,
    //   name: 'faculty65',
    //   calories: 'faculty65@gmail.com',
    //   carbs: 'test3',
    //   // capacity: '',
    //   assign_to: 'room3',
    //   venue_link: 'Assigned',
    // },
  ]);
  const history = useHistory();
  const classes = useStyles();
  const SEATING_COLUMNS = 6;
  const [dataCourse, setdataCourse] = useState();

  //Get Data from API through params : id

  // Tab Panel states
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  // Automatic select
  const [selectValueCourse, setSelectValueCourse] = useState(
    selectOptionsCourse[0].value
  );
  const handleSelectChangeCourse = (e) => {
    setSelectValueCourse(e.target.value);
  };

  const [Rooms, setRooms] = useState();
  const [respData, setRespData] = useState({});
  const [loading, setIsLoading] = useState(false);
  let nameForCourse;
  // onDataSave = () => {};
  const saveData = () => {
    console.log('object');
    const newData = [...rows];

    const payload = newData.map((row) => {
      return {
        facultyId: row.id,
        roomNo: row.assign_to,
        examId: Exam_id_id.id,

        facRole: row.carbs,
        facEmail: row.calories,
        isAllocated: row.venue_link,
        sendEmail: false,
      };
    });
    setRespData({ success: 'true', message: 'Data updated Successfully' });
    postInvigilator_s2_Data(payload)
      .then((res) => {
        /* enable on res success */
        // setRespData(res)
        getInvigilator_s2_DataListing();
      })
      .catch((err) => {
        alert('Failed to add. Please try again.');
      });
  };
  /* send mail  */
  useEffect(() => {
    if (respData.success === 'true') {
      sendMailInvigilator();
    }
  }, [respData]);
  const getInvigilator_s2_DataListing = () => {
    setIsLoading(true);

    let filterData = {
      id: Exam_id_id.id,
    };

    getInvigilator_s2_Data(filterData).then((res) => {
      setIsLoading(false);
      console.log('resssssssssssssssssssssssssss', res);
      const EvaluationDetailsInfo =
        res?.data?.faculties === null
          ? []
          : res?.data?.faculties.map((item, index) => {
              console.log('krishnaaaaaaa', item);
              return {
                button: 'assign',
                faucltyId: item.contactId,
                id: item.contactId,
                name: item.contactName ? item.contactName : '',
                carbs: item.role ? item.role : '',
                calories: item.contactEmail ? item.contactEmail : '',
                // capacity: '',
                assign_to: item.roomAllotedName ? item.roomAllotedName : '',
                venue_link: item.status ? item.status : '',
              };
            });
      setRows(EvaluationDetailsInfo);
      console.log('krishnarowsssssssssssss', rows);
      console.log('EvaluationDetailsInfo12', EvaluationDetailsInfo);
      const EvaluationDetailsInfosss =
        res?.data?.facilities === null
          ? []
          : res?.data?.facilities.map((item, index) => {
              return { label: item.facilityName, value: item.facilityId };
              // let roomAllocted = [];
              // item.facultyList.map((map) => {
              //   return roomAllocted.push(map.allocatedRoomNo);
              // });

              // item.roomNo = item.roomNo.filter(
              //   (val) => !roomAllocted.includes(val)
              // );

              // let subjectName = item.roomNo
              //   ? item.roomNo.map((e) => {
              //       return { label: e, value: e };
              //     })
              //   : '';

              // return subjectName;
            });
      setRooms(EvaluationDetailsInfosss);
      console.log('EvaluationDetailsInfosss', EvaluationDetailsInfosss);
      setIsLoading(false);

      setRows(EvaluationDetailsInfo);
      console.log('rommsssss', Rooms);
      console.log('EvaluationDetailsInfo', EvaluationDetailsInfo);
    });
  };

  let email = [];

  rows.map((item) => {
    console.log('userEmailid', item.calories);
    return email.push(item.calories);
  });

  const CustomTableCellForDropDownAssignto = ({ row, name, onChange }) => {
    const { isEditMode } = row;

    return (
      <TableCell align="left">
        {isEditMode ? (
          <Box>
            <Box>
              <KenSelect
                name={name}
                options={Rooms}
                value={row[name]}
                dropdownColor="#ffffff"
                onChange={(e) => onChange(e, row)}
                required={true}
              />
            </Box>
          </Box>
        ) : (
          row[name]
        )}
      </TableCell>
    );
  };

  useEffect(() => {
    getInvigilator_s2_DataListing();
    // emaild();
  }, []);

  console.log('krishnarowwwwwwwwwwwwww', rows);

  return (
    <Box>
      {loading && <KenLoader />}
      <Box className={classes.breadCrumbWrapper}>
        <BreadCrumb array={arrayBreadCrumb} history={history} />
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Invigilation and proctoring Assignment
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              style={{ marginRight: '10px' }}
              variant="contained"
              color="primary"
              onClick={() => history.goBack()}
            >
              Back
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              onClick={saveData}
              // className={classes.addButton}
            >
              Save
            </Button>
          </Grid>
        </Toolbar>
      </AppBar>

      <div className="cardlsitbox">
        <Box className={`cardlsitbox`}>
          <KenCard elevation={0}>
            <Table className={classes.table} aria-label="caption table">
              <TableHead>
                <TableRow style={{ background: '#FFFFFF' }}>
                  <TableCell
                    align="left"
                    style={{
                      background: '#FFFFFF',
                      color: '#193389',
                      fontSize: '12px',
                    }}
                  >
                    INVIGILATOR NAME
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      background: '#FFFFFF',
                      color: '#193389',
                      fontSize: '12px',
                    }}
                  >
                    Role
                  </TableCell>
                  {/* <TableCell align="left" style={{ background: '#FFFFFF',color:"#193389",fontSize:"12px", }}>FACULTY HISTORY</TableCell> */}
                  <TableCell
                    align="left"
                    style={{
                      background: '#FFFFFF',
                      color: '#193389',
                      fontSize: '12px',
                    }}
                  >
                    Faculty Email
                  </TableCell>

                  <TableCell
                    align="left"
                    style={{
                      background: '#FFFFFF',
                      color: '#193389',
                      fontSize: '12px',
                    }}
                  >
                    ROOM ALLOTMENT
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      background: '#FFFFFF',
                      color: '#193389',
                      fontSize: '12px',
                    }}
                  >
                    ASSIGN TO
                  </TableCell>

                  {/* <TableCell align="left" style={{ background: '#FFFFFF',color:"#193389",fontSize:"12px", }}>FACULTY CAPACITY</TableCell> */}
                  <TableCell
                    align="left"
                    style={{
                      background: '#FFFFFF',
                      color: '#193389',
                      fontSize: '12px',
                    }}
                  >
                    EDIT
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.length === 0 && (
                  <TableCell colSpan={5}>No Record</TableCell>
                )}
                {rows?.map((row) => (
                  <TableRow key={row.faucltyId}>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.carbs}</TableCell>
                    <TableCell>{row.calories}</TableCell>
                    <CustomTableCellForDropDownAssignto
                      {...{ row, name: 'assign_to', onChange }}
                    />
                    <TableCell>{row.venue_link}</TableCell>
                    {/* <CustomTableCellForDropDown
                      {...{ row, name: 'venue_link', onChange }}
                    /> */}
                    {/* <TableCell>{row.capacity}</TableCell> */}
                    <TableCell className={classes.selectTableCell}>
                      {row.isEditMode ? (
                        <>
                          <IconButton
                            aria-label="done"
                            onClick={() => onToggleEditMode('done', row.id)}
                          >
                            <DoneIcon />
                          </IconButton>
                          <IconButton
                            aria-label="revert"
                            onClick={() => onRevert(row.id, 'revert')}
                          >
                            <RevertIcon />
                          </IconButton>
                        </>
                      ) : (
                        <IconButton
                          aria-label="delete"
                          onClick={() => onToggleEditMode('edit', row.id)}
                        >
                          <EditIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </KenCard>
        </Box>
      </div>
    </Box>
  );
};

export default InvigilationAssign;
